import VerificarUsuario from "../../helpers/usuario/verificarUsuario";

/**
 * Componente de observaciones del contribuyente
 * @param {Object} param0 
 * @returns Componente React
 */
export default function ContactoObservaciones({ data, setData }) {

    VerificarUsuario();
    const { contribuyente } = data;

    return (
        <div id="observaciones" className="tabcontent">
            <div className="formulario">
                <div className="boxRow">
                    <div className="boxColumn">
                        <label className="lblCampo">Observaciones</label>
                        <div className="search-bar-textarea">
                            <textarea name="textarea" rows="3" cols="1"
                                value={contribuyente?.observaciones === undefined ? "" : contribuyente?.observaciones}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, observaciones: e.target.value.toUpperCase() } })}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
